import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import 'rxjs/add/operator/map';
import { ServiceAddon } from '../_models/serviceaddon';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from './index';


@Injectable()
export class ServiceAddonsService {
  private baseUrl: string = this.environmentService.getBaseURL() + '/api';

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService) {
  }


  getAll(): Observable<ServiceAddon[]>{
  // new change - get current logged dealer id
    let serviceaddon$ = this.http
      .get(`${this.baseUrl}/serviceaddons`, this.makeHeaders())
      .map(mapServiceAddons)
      .catch(handleError);
    return serviceaddon$;
  }

  getDealer(id: string,type: string): Observable<ServiceAddon[]>{
    let serviceaddon$ = this.http
      .get(`${this.baseUrl}/serviceaddons?dealer_id=${id}&type=${type}`, this.makeHeaders())
      .map(mapServiceAddons)
      .catch(handleError);
    return serviceaddon$;
  }

  create(serviceaddon : ServiceAddon) : Observable<ServiceAddon> {
    let newserviceaddon = this.http
      .post(`${this.baseUrl}/serviceaddons`, JSON.stringify(serviceaddon), this.makeHeaders())
      .map(mapServiceAddon);
    return newserviceaddon;
  }

  read(id: string): Observable<ServiceAddon> {
    let serviceaddon = this.http
      .get(`${this.baseUrl}/serviceaddons/${id}`, this.makeHeaders())
      .map(mapServiceAddon);
    return serviceaddon;
  }
  update(serviceaddon: ServiceAddon) : Observable<Response>{
    return this.http
      .put(`${this.baseUrl}/serviceaddons/${serviceaddon._id}`, JSON.stringify(serviceaddon), this.makeHeaders());
  }
  delete(id: string) : Observable<Response>{
    return this.http
      .delete(`${this.baseUrl}/serviceaddons/${id}`, this.makeHeaders())
        .map((res:Response) => res.json()) // ...and calling .json() on the response to return data
        .catch((error:any) => Observable.throw(error.json().error || 'Server error')); //...errors if any
  }

  private makeHeaders():RequestOptions {
    let headers = new Headers();

    headers.append('Authorization', this.authenticationService.getToken());
    headers.append('Content-Type', 'application/json ');
    headers.append('charset', 'UTF-8 ');
    headers.append('Accept', 'application/json ');

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}
function mapServiceAddons(response:Response): ServiceAddon[]{
   // uncomment to simulate error:
   // throw new Error('ups! Force choke!');
   return response.json().map(toServiceAddon);
}

function toServiceAddon(r:any): ServiceAddon{
  let serviceaddon = <ServiceAddon>({
      _id: r._id,
      dealer_id: r.dealer,
      name: r.name,
      price: r.price,
      type: r.type
  });
  return serviceaddon;
}

function mapServiceAddon(response:Response): ServiceAddon{
  // toPerson looks just like in the previous example
  return toServiceAddon(response.json());
}

// this could also be a private method of the component class
function handleError (error: any) {
  // log error
  // could be something more sofisticated
  let errorMsg = error.message || `Yikes! There was was a problem with our hyperdrive device and we couldn't retrieve your data!`
  console.error(errorMsg);

  // throw an application level error
  return Observable.throw(errorMsg);
}



// WEBPACK FOOTER //
// ./src/app/_services/serviceaddons.service.ts